import "core-js/modules/web.dom-collections.iterator.js";
import { useEffect, useState } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PrintViewMap = props => {
  const [map, setMap] = useState(null);
  const [isError, setError] = useState(false);
  useEffect(() => {
    setMap(null);
    props.screenshot.then(setMap).catch(() => setError(true));
  }, [props.screenshot]);
  return isError ? /*#__PURE__*/_jsx("div", {
    children: "Error has occured"
  }) : map ? /*#__PURE__*/_jsxs("div", {
    className: "mapContainer",
    children: [/*#__PURE__*/_jsx("img", {
      className: "map-image",
      src: map,
      alt: "Map snapshot"
    }), props.children]
  }) : /*#__PURE__*/_jsx("div", {
    children: "Loading"
  });
};
export default PrintViewMap;